import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { subscribe } from 'alfa';
import { Alert, Typography, message } from 'antd';
import { withTranslation } from 'react-i18next';

import APIKeyCreationForm from './components/creation-form';
import Link from '../../components/link';
import APIKeyRepo from '../../repository/api-key';

const { Title } = Typography;

const Result = (props) => {
  const { apikey, t } = props;
  const jwk = JSON.stringify(apikey.jwk);

  return (
    <div>
      <Alert type="warning" message={`${t('important')}!`} description={t('api_key.created_warning')} style={{ marginBottom: '20px' }} />
      <p>
        <strong>{t('api_key.username')} (ID):</strong>
      </p>
      <pre>{apikey.id}</pre>
      <p>
        <strong>{t('api_key.password')} (Token):</strong>
      </p>
      <pre>{apikey.token}</pre>
      <p>
        <strong>{t('api_key.private_key')}:</strong>
      </p>
      <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{jwk}</pre>
      <Link to="/api-keys" button>{t('api_key.confirm')}</Link>
    </div>
  );
};

Result.propTypes = {
  apikey: PropTypes.shape({
    id: PropTypes.string,
    jwk: PropTypes.any,
    token: PropTypes.string,
  }),
  t: PropTypes.func,
};

const APIKeyNew = withTranslation()((props) => {
  const { business, t } = props;
  const [loading, setLoading] = useState(false);
  const [apiKey, setAPIKey] = useState(null);

  const submit = async (desc) => {
    setLoading(true);
    try {
      const { data } = await APIKeyRepo.create(business, { reference: desc });
      setAPIKey(data);
    } catch (error) {
      message.error(t('error.creating_api_key'));
      console.error('ERROR: APIKeyNew: APIKeyRepo.create()', error); // eslint-disable-line no-console
    } finally {
      setLoading(false);
    }
  };

  if (apiKey) {
    return (
      <>
        <Title level={3}>{t('api_key.created')}</Title>
        <Result apikey={apiKey} {...props} />
      </>
    );
  }

  return (
    <>
      <Title level={3}>{t('create_api_key')}</Title>
      <APIKeyCreationForm onSubmit={submit} loading={loading} />
    </>
  );
});

export default subscribe(APIKeyNew, ['business']);
